import cx from 'classnames';
import {
    ExclamationTriangleIcon,
    InformationCircleIcon,
    CheckCircleIcon,
} from '@heroicons/react/24/outline';

export interface MessageProps {
    className?: string;
    message?: React.ReactNode;
    error?: React.ReactNode;
    success?: React.ReactNode;
    warning?: React.ReactNode;
    size?: 'small' | 'large';
    height?: number;
}

export const Message: React.FC<MessageProps> = ({
    className,
    message,
    error,
    success,
    warning,
    size = 'large',
    height = 40,
}) => {
    const messageToRender = message || error || success || warning;

    if (messageToRender) {
        return (
            <div
                className={cx(
                    className,
                    'flex items-start justify-start gap-2',
                    {
                        'text-success-700': success,
                        'text-danger-700': error,
                        'text-warning-700': warning,
                        'text-gray-900': !error && !success && !warning,
                        'text-small': size === 'small',
                    },
                )}
                style={{ height }}
            >
                <div
                    className={cx({
                        'text-x-large': size === 'large',
                        'text-large': size === 'small',
                    })}
                >
                    {error && <ExclamationTriangleIcon className="h-6 w-6" />}
                    {warning && <InformationCircleIcon className="h-6 w-6" />}
                    {success && <CheckCircleIcon className="h-6 w-6" />}
                </div>
                {messageToRender}
            </div>
        );
    }

    return <div style={{ height }} />;
};
